import { render, staticRenderFns } from "./sixInput.vue?vue&type=template&id=a6bfa0d4&scoped=true&"
import script from "./sixInput.vue?vue&type=script&lang=js&"
export * from "./sixInput.vue?vue&type=script&lang=js&"
import style0 from "./sixInput.vue?vue&type=style&index=0&id=a6bfa0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bfa0d4",
  null
  
)

export default component.exports